import * as React from "react";
import {
  Input,
  Col,
  Form,
  Checkbox,
  Row,
  Button,
  Select,
  Card,
  Spin,
  Popconfirm
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { TCaseLawDocumentPresentationModel } from "../../presenter/model/CaseLawDocumentPresentationModel";
import { IOrganisation } from "../../../organisations/model/Organisation";
import SelectInput from "../../../core/ui/components/SelectInput";
import { CaseLawDocumentStatus, CourtCaseType } from "../../common/Constants";
import { ICourtCase } from "../../model/CourtCase";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import DateTimePicker from "../../../core/ui/components/DateTimePicker";
import { DateFormats } from "../../../core/common/Constants";
import { IUser } from "../../../user/model/User";
import SearchInput from "./SearchInput";
import TranslationTextAreaField from "../../../core/ui/components/TranslationTextAreaField";
import { IStore } from "../../../core/model/runtime/state/Store";
import { TOrganisationIndexGroupPresentationModel } from "../../../organisations/presenter/model/OrganisationIndexGroupPresentationModel";
import { IDocumentTypeIndexCategory } from "../../../documentTypes/model/DocumentTypeIndexCategory";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import CourtCaseEntryForm from "./CourtCaseEntryForm";
import { TCourtCaseSelectionModel } from "../../presenter/CaseLawDocumentCreationPresenter";
import moment from "moment";
import FormSection from "../../../core/ui/components/FormSection";
import CaseLawDocumentCourtCaseDescription from "./CaseLawDocumentCourtCaseDescription";
import { TCourtCaseConnectionType } from "../../model/CourtCaseConnectionType";
import CreateModal from "../../../core/ui/components/grid/CreateModal";
import CourtCaseCreationForm from "./CourtCaseCreationForm";
import { IAttachment } from "../../model/Attachment";
import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import CourtCaseNumberInput from "../../../core/ui/components/CourtCaseNumberInput";
import { IIndexTypeAttribute } from "../../../indexTypes/model/IndexTypeAttribute";
import { IIndexAttributeData } from "../../../indexTypes/model/IndexAttributeData";
import IndexAttributeDataForm from "./IndexAttributeDataForm";

const FormFields = {
  ID: "id",
  SEARCH_ID: "searchId",
  NOTES: "notes",
  SUMMARY: "summary",
  STATUS: "status",
  CASE_LAW_DOCUMENT_TYPE_CODE: "documentTypeId",
  COURT_CASE: "courtCaseList",
  ORGANISATION_ID: "organisationId",
  VALID: "valid",
  PRIMARY_COURT_CASE: "primaryCourtCase",
  DATE: "caseLawDocDate",
  PARENT_GROUP: "parentGroup",
  SECOND_GROUP: "secondGroup",
  INVALIDATE_PUBLISHED_CASE_LAW_DOCS: "invalidatePublishedCaseLawDocs",
  INVALIDATED_CASE_LAW_DOCUMENTS: "invalidatedCaseLawDocuments",
  CASE_LAW_DOCUMENT_ID: "caseLawDocumentId",
  INVALIDATION_REASON: "invalidationReason"
};

const CaseLawDocumentForm = ({
  translate,
  rowData,
  caseLawDocumentTypes,
  organisations,
  setOrganisationId,
  organisationIndexes,
  setInvalidatePublishedCaseLawDocuments,
  publishedCaseLawDocuments,
  organisationCaseLawDocumentTypeId,
  onSubmit,
  showCaseLawDocumentList,
  findCourtCaseDetails,
  courtCase,
  setCaseLawDocumentTypeCode,
  user,
  parentGroupList,
  secondGroupList,
  selectedParentGroupId,
  selectedSecondGroupId,
  setParentGroupId,
  setSecondGroupId,
  onSearch,
  invalidatePublishedCaseLawDocsVisible,
  selectedOrganisationId,
  courtCaseDetailsModalVisible,
  onHideCourtCaseDetailsModal,
  updateCourtCaseSelection,
  courtCaseSelectionResult,
  store,
  loaders,
  createCourtCasePopupVisible,
  createCourtCaseModalVisible,
  showCreateCourtCasePopupVisible,
  showCreateCourtCaseModalVisible,
  courtCaseConnectionTypeList,
  createCourtCase,
  nonExistantCourtCaseNumber,
  createAttachment,
  uploadedAttachment,
  courtCaseValidationStatus,
  courtCaseHelpText,
  onRaiseValidationError,
  courtCaseTypes,
  decisionTypes,
  indexTypeAttributes,
  setAttributesData,
  indexAttributeDataList,
  closeIndexDataModal,
  openIndexDataModal,
  indexDataModalVisible,
  saveAttributeData,
  selectedIndexForAttribute
}: {
  translate: any;
  rowData?: TCaseLawDocumentPresentationModel;
  caseLawDocumentTypes: IDocumentType[];
  organisations: IOrganisation[];
  setOrganisationId: any;
  organisationIndexes: IDocumentTypeIndexCategory[];
  setInvalidatePublishedCaseLawDocuments: (value: boolean) => void;
  publishedCaseLawDocuments: any;
  selectedIndex?: any;
  organisationCaseLawDocumentTypeId?: number;
  nonAnonymisedAttachmentsCount?: number;
  onSubmit?: any;
  showCaseLawDocumentList: any;
  connectedCourtCasesList: ICourtCase[];
  createConnectedCourtCase;
  removeConnectedCourtCase;
  findCourtCaseDetails;
  courtCase?: ICourtCase;
  user?: IUser;
  setCaseLawDocumentTypeCode: (code: number) => void;
  parentGroupList: TOrganisationIndexGroupPresentationModel[][];
  secondGroupList: TOrganisationIndexGroupPresentationModel[][];
  selectedParentGroupId: number[];
  selectedSecondGroupId: number[];
  setParentGroupId: (selectedParentGroupId: number, index: number) => void;
  setSecondGroupId: (selectedSecondGroupId: number, index: number) => void;
  invalidatePublishedCaseLawDocsVisible: boolean;
  onSearch: (value: string) => void;
  selectedOrganisationId;
  store: IStore;
  courtCaseDetailsModalVisible?: boolean;
  onHideCourtCaseDetailsModal(): void;
  updateCourtCaseSelection(value: TCourtCaseSelectionModel): void;
  courtCaseSelectionResult?: TCourtCaseSelectionModel;
  loaders;
  courtCaseConnectionTypeList: TCourtCaseConnectionType[];
  createCourtCasePopupVisible: boolean;
  createCourtCaseModalVisible: boolean;
  createCourtCase(courtCase: ICourtCase): void;
  showCreateCourtCasePopupVisible(value: boolean): void;
  showCreateCourtCaseModalVisible(value: boolean): void;
  nonExistantCourtCaseNumber?: string;
  createAttachment(file: any, fileName?: string): any;
  uploadedAttachment?: IAttachment;
  courtCaseValidationStatus?: "error" | "";
  courtCaseHelpText?: string;
  onRaiseValidationError(error: any): void;
  courtCaseTypes: IGenericCodebookItem[];
  decisionTypes: IGenericCodebookItem[];
  indexTypeAttributes?: IIndexTypeAttribute[];
  setAttributesData?: any;
  indexAttributeDataList?: IIndexAttributeData[];
  closeIndexDataModal: any;
  openIndexDataModal: any;
  indexDataModalVisible: boolean;
  saveAttributeData: any;
  selectedIndexForAttribute: any;
}) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const [createCourtCaseForm] = Form.useForm();

  function findCourtCase() {
    findCourtCaseDetails(form.getFieldValue("primaryCourtCase"));
  }
  function addCourtCaseNumber(caseNumber: string) {
    form.setFieldsValue({ primaryCourtCase: caseNumber });
    findCourtCase();
  }
  function onChangeOrganisation(item) {
    setOrganisationId(item);
  }
  function onChangeCaseLawDocumentCode(item) {
    setCaseLawDocumentTypeCode(item);
  }
  function onChangeParentGroup(value, index) {
    setParentGroupId(value, index);
    form.setFields([
      {
        name: ["secondGroup", index],
        value: undefined
      },
      {
        name: ["organisationIndexList", index],
        value: undefined
      }
    ]);
    setSecondGroupId(NaN, index);
  }
  function onChangeSecondGroup(value, index) {
    setSecondGroupId(value, index);
    if (selectedParentGroupId.length == 0) {
      setParentGroupId(
        secondGroupList[index].find((elem) => elem.id === value)?.parentId ??
          NaN,
        index
      );
      form.setFields([
        {
          name: ["parentGroup", index],
          value:
            secondGroupList[index].find((elem) => elem.id === value)
              ?.parentId ?? NaN
        }
      ]);
      form.setFieldsValue({
        organisationIndexList: undefined
      });
    }
  }
  function filterIndexData(list, index) {
    let newList = list;
    if (selectedParentGroupId[index]) {
      newList = list.filter(
        (item) =>
          item.groups.findIndex(
            (element) => element.id === selectedParentGroupId[index]
          ) !== -1
      );
    }
    if (selectedSecondGroupId[index]) {
      newList = newList.filter(
        (item) =>
          item.groups.findIndex(
            (element) => element.id === selectedSecondGroupId[index]
          ) !== -1
      );
    }

    return newList;
  }
  const getCorrectIndexTranslation = (index: any) => {
    const { selectedLanguage } = store.getState<any>();
    const nameTranslation = index.nameTranslations.find(
      (item) => item.languageId === selectedLanguage?.id
    )?.nameTranslation;
    return nameTranslation ?? index.name;
  };

  const getCorrectGroupTranslation = (data?: any) => {
    const { selectedLanguage } = store.getState<any>();
    if (data) {
      const nameTranslation = data.nameTranslations.find(
        (item) => item.languageId === selectedLanguage?.id
      )?.nameTranslation;
      return nameTranslation ?? data.name;
    } else {
      return "";
    }
  };
  function findParent(group, groupList, data) {
    if (group?.parentId) {
      let g = groupList.find((g) => g.id === group?.parentId);
      if (g) {
        data = data + ` 🡐 ${getCorrectGroupTranslation(g)}`;
        return findParent(g, groupList, data);
      }
    } else if (group?.organisationIndexCategory) {
      data =
        data +
        ` 🡐 ${getCorrectGroupTranslation(group?.organisationIndexCategory)}`;
    }
    return data;
  }
  function setCheckboxValue(value: boolean) {
    !value &&
      form.setFieldsValue({
        invalidatedCaseLawDocuments: undefined,
        invalidationReason: undefined
      });
    setInvalidatePublishedCaseLawDocuments(value);
  }
  function renderOptions(list) {
    return list.map((index) => {
      let data = getCorrectIndexTranslation(index);
      if (index.groups) {
        let firstGroup = index.groups.find(
          (g) => g.id === index.organisationGroupId
        );
        data = `${getCorrectIndexTranslation(
          index
        )} 🡐 ${getCorrectGroupTranslation(firstGroup)}`;
        data = findParent(firstGroup, index.groups, data);
      }
      return (
        <Option
          key={`option-item-${index.id}`}
          value={index.id}
          title={data}
          label={data}
        >
          {data}
        </Option>
      );
    });
  }

  !rowData &&
    organisationCaseLawDocumentTypeId &&
    form.setFieldsValue({
      documentTypeId: organisationCaseLawDocumentTypeId
    });
  user &&
    user.isOperator() &&
    form.setFieldsValue({
      organisationId: user.organisationId
    });

  return (
    <Form
      layout={"vertical"}
      form={form}
      initialValues={{
        courtCaseList: [{ courtCaseNumber: "" }],
        summaryTranslations: [
          {
            summaryTranslation: "",
            languageId: store.getState<any>().selectedLanguage.id
          }
        ]
      }}
    >
      <Row align="middle" justify="center">
        <Col xl={20} lg={24} md={24} sm={24} xs={24}>
          <Card bordered={false}>
            <FormSection
              title={translate("editors.case_law_documents.document_details")}
              subtitle={translate(
                "editors.case_law_documents.basic_document_details"
              )}
            >
              <Form.Item
                name={FormFields.ID}
                initialValue={rowData?.id}
                style={{ display: "none" }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={FormFields.SEARCH_ID}
                initialValue={rowData?.searchId}
                style={{ display: "none" }}
              >
                <Input />
              </Form.Item>
              <Row style={user?.isOperator() ? { display: "none" } : {}}>
                <Col
                  md={24}
                  sm={24}
                  xs={24}
                  style={{
                    display: "flex"
                  }}
                >
                  <Form.Item
                    style={{ display: "none" }}
                    label={translate("editors.case_law_documents.status")}
                    name={FormFields.STATUS}
                    initialValue={
                      rowData?.status ?? CaseLawDocumentStatus.IN_PROGRESS
                    }
                    className={"mb-0"}
                    rules={[
                      {
                        required: true,
                        message: translate(
                          "editors.case_law_documents.required_messages",
                          {
                            field: translate(
                              "editors.case_law_documents.status"
                            )
                          }
                        )
                      }
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item
                    label={translate(
                      "editors.case_law_documents.organisation_name"
                    )}
                    name={FormFields.ORGANISATION_ID}
                    initialValue={
                      user?.isOperator() ? user.organisationId : undefined
                    }
                    rules={[
                      {
                        required: true,
                        message: translate(
                          "editors.case_law_documents.required_messages",
                          {
                            field: translate(
                              "editors.case_law_documents.organisation_name"
                            )
                          }
                        )
                      }
                    ]}
                  >
                    <SelectInput
                      placeholder={translate(
                        "editors.case_law_documents.select_organisation"
                      )}
                      allowClear
                      showSearch={true}
                      notFoundContent={translate("search.no_data")}
                      selectOptionKey={"id"}
                      selectOptionValue={"name"}
                      selectOptions={organisations}
                      onChange={(value) => onChangeOrganisation(value)}
                    />
                  </Form.Item>
                </Col>
                <Col
                  lg={4}
                  md={6}
                  sm={10}
                  xs={24}
                  style={{
                    display: "none",
                    alignItems: "center"
                  }}
                >
                  <Form.Item
                    label={translate("editors.case_law_documents.valid")}
                    className={"png-form-item-horizontal-checkbox mb-0"}
                    name={FormFields.VALID}
                    valuePropName={"checked"}
                    initialValue={rowData?.valid ?? true}
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col
                  xs={24}
                  sm={24}
                  style={
                    user?.isOperator() && caseLawDocumentTypes?.length === 1
                      ? { display: "none" }
                      : {}
                  }
                >
                  <Form.Item
                    label={translate(
                      "editors.case_law_documents.case_law_document_type"
                    )}
                    name={FormFields.CASE_LAW_DOCUMENT_TYPE_CODE}
                    initialValue={
                      rowData?.documentTypeId
                        ? rowData?.documentTypeId
                        : organisationCaseLawDocumentTypeId || undefined
                    }
                    className={"mb-0"}
                    rules={[
                      {
                        required: true,
                        message: translate(
                          "editors.case_law_documents.required_messages",
                          {
                            field: translate(
                              "editors.case_law_documents.case_law_document_type"
                            )
                          }
                        )
                      }
                    ]}
                  >
                    <SelectInput
                      disabled={
                        form.getFieldValue("organisationId") === undefined
                      }
                      placeholder={translate(
                        "editors.case_law_documents.select_case_law_document_type"
                      )}
                      allowClear
                      defaultActiveFirstOption={true}
                      showSearch={true}
                      notFoundContent={translate("search.no_data")}
                      selectOptionKey={"id"}
                      selectOptionValue={"name"}
                      selectOptions={caseLawDocumentTypes}
                      className={"mb-0"}
                      onChange={(value) => onChangeCaseLawDocumentCode(value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ marginBottom: 30, marginTop: 12 }}>
                <Col sm={24} xs={24}>
                  <Form.Item
                    label={translate("editors.case_law_documents.date")}
                    name={FormFields.DATE}
                    initialValue={moment(rowData?.caseLawDocDate || new Date())}
                    rules={[
                      {
                        required: true,
                        message: translate(
                          "editors.case_law_documents.required_messages",
                          {
                            field: translate("editors.case_law_documents.date")
                          }
                        )
                      }
                    ]}
                  >
                    <DateTimePicker
                      placeholder={translate("date_picker.placeholder")}
                      format={DateFormats.DATE}
                      showToday={true}
                      className={"input-date-wrapper"}
                      translate={translate}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </FormSection>
            <FormSection
              title={translate(
                "editors.case_law_documents.sections.case_law_document_title"
              )}
              subtitle={translate(
                "editors.case_law_documents.sections.case_law_document_subtitle"
              )}
            >
              <Row>
                <Col xs={24} sm={24}>
                  <Form.Item
                    label={translate(
                      "editors.case_law_documents.primary_court_case"
                    )}
                    className={"mb-0"}
                    help={courtCaseHelpText}
                    validateStatus={courtCaseValidationStatus}
                    name={FormFields.PRIMARY_COURT_CASE}
                    rules={[
                      {
                        required: true,
                        message: translate(
                          "editors.case_law_documents.required_messages",
                          {
                            field: translate(
                              "editors.case_law_documents.primary_court_case"
                            )
                          }
                        )
                      }
                    ]}
                  >
                    <CourtCaseNumberInput onSearch={addCourtCaseNumber} />
                  </Form.Item>

                  {courtCaseSelectionResult && (
                    <Col style={{ marginTop: 20 }}>
                      <CaseLawDocumentCourtCaseDescription
                        courtCase={courtCaseSelectionResult?.courtCase}
                        translate={translate}
                        decisionTypes={decisionTypes}
                      />
                    </Col>
                  )}
                  <CreateModal
                    translate={translate}
                    title={translate("editors.court_cases.add_new_court_case")}
                    visible={createCourtCaseModalVisible}
                    onCreate={(item: ICourtCase) => {
                      createCourtCase(item);
                      createCourtCaseForm.resetFields();
                      showCreateCourtCaseModalVisible(false);
                    }}
                    onCancel={() => {
                      createCourtCaseForm.resetFields();
                      showCreateCourtCaseModalVisible(false);
                    }}
                    Form={
                      <CourtCaseCreationForm
                        translate={translate}
                        form={createCourtCaseForm}
                        setFileValue={createAttachment}
                        uploadedAttachment={uploadedAttachment}
                        courtCaseTypes={courtCaseTypes}
                        decisionTypes={decisionTypes}
                      />
                    }
                    formInstance={createCourtCaseForm}
                    className={"modal-width"}
                    rowData={{
                      type: CourtCaseType.PRIMARY,
                      courtCaseNumber: nonExistantCourtCaseNumber ?? ""
                    }}
                  />
                  <Popconfirm
                    title={translate(
                      "editors.court_cases.non_existing_court_case_popconfirm_message"
                    )}
                    visible={createCourtCasePopupVisible}
                    onCancel={() => showCreateCourtCasePopupVisible(false)}
                    onConfirm={() => {
                      showCreateCourtCaseModalVisible(true);
                      showCreateCourtCasePopupVisible(false);
                    }}
                  />
                </Col>
              </Row>

              <Row gutter={16} style={{ marginBottom: 10, marginTop: 10 }}>
                <Col xs={24} sm={24}>
                  <TranslationTextAreaField
                    translate={translate}
                    organisationId={selectedOrganisationId}
                    translationObjectIdFieldName={"caseLawDocumentId"}
                    store={store}
                    form={form}
                    label={translate("editors.case_law_documents.summary")}
                  />
                </Col>
              </Row>
              <Form.Item
                className={"png-form-item-horizontal-checkbox mb-0"}
                name={FormFields.INVALIDATE_PUBLISHED_CASE_LAW_DOCS}
                valuePropName={"checked"}
                initialValue={false}
              >
                <Checkbox onChange={(e) => setCheckboxValue(e.target.checked)}>
                  {translate("editors.case_law_documents.should_invalidate")}
                </Checkbox>
              </Form.Item>
              {invalidatePublishedCaseLawDocsVisible && (
                <div>
                  <Form.Item
                    label={translate(
                      "editors.case_law_documents.case_law_documents_to_be_invalidated"
                    )}
                    className={"mb-0"}
                    name={FormFields.INVALIDATED_CASE_LAW_DOCUMENTS}
                  >
                    <SearchInput
                      mode={"multiple"}
                      data={publishedCaseLawDocuments}
                      placeholder={translate(
                        "editors.case_law_documents.search_case_law_documents"
                      )}
                      translate={translate}
                      searchAndUpdateData={onSearch}
                      onChange={(value) =>
                        form.setFieldsValue({
                          invalidatedCaseLawDocuments: value
                        })
                      }
                    ></SearchInput>
                  </Form.Item>
                  <Form.Item
                    className={"mb-0"}
                    label={translate(
                      "editors.case_law_documents.invalidation_reason"
                    )}
                    name={FormFields.INVALIDATION_REASON}
                  >
                    <TextArea />
                  </Form.Item>
                </div>
              )}
              <div style={{ marginTop: 32 }}>
                <Form.Item
                  name={FormFields.NOTES}
                  label={translate("editors.case_law_documents.notes")}
                >
                  <TextArea></TextArea>
                </Form.Item>
              </div>
            </FormSection>
            {organisationIndexes?.length > 0 && (
              <FormSection
                title={translate("editors.case_law_documents.classification")}
                subtitle={translate(
                  "editors.case_law_documents.sections.index_subtitle"
                )}
              >
                <Spin
                  spinning={loaders.caseLawDocumentIndexDataLoader || false}
                >
                  {organisationIndexes.map((item, index) => {
                    return (
                      <Row
                        key={`index-item-${index}`}
                        gutter={16}
                        style={{
                          marginTop: 10,
                          alignItems: "center"
                        }}
                      >
                        <Col
                          md={24}
                          sm={24}
                          xs={24}
                          style={{
                            marginTop: 20,
                            alignItems: "center"
                          }}
                        >
                          <Form.Item
                            label={translate(
                              "editors.case_law_documents.parent_group"
                            )}
                            className={"mb-0"}
                            name={[FormFields.PARENT_GROUP, index]}
                          >
                            <SelectInput
                              placeholder={translate(
                                "editors.case_law_documents.select_parent_group"
                              )}
                              allowClear
                              showSearch={true}
                              notFoundContent={translate("search.no_data")}
                              selectOptionKey={"id"}
                              selectOptionValue={"name"}
                              selectOptions={parentGroupList[index]}
                              onChange={(value) => {
                                onChangeParentGroup(value, index);
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col
                          md={24}
                          sm={24}
                          xs={24}
                          style={{
                            marginTop: 20,
                            display: "none",
                            alignItems: "center"
                          }}
                        >
                          <Form.Item
                            label={translate(
                              "editors.case_law_documents.second_group"
                            )}
                            className={"mb-0"}
                            name={[FormFields.SECOND_GROUP, index]}
                          >
                            <SelectInput
                              style={{ minWidth: "100%" }}
                              allowClear
                              placeholder={translate(
                                "editors.case_law_documents.select_second_group"
                              )}
                              showSearch={true}
                              notFoundContent={translate("search.no_data")}
                              selectOptionKey={"id"}
                              selectOptionValue={"nameTranslation"}
                              selectOptions={
                                selectedParentGroupId
                                  ? secondGroupList[index].filter(
                                      (elem) =>
                                        elem.parentId ===
                                        selectedParentGroupId[index]
                                    )
                                  : secondGroupList[index]
                              }
                              onChange={(value) => {
                                onChangeSecondGroup(value, index);
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col
                          lg={24}
                          md={24}
                          sm={24}
                          xs={24}
                          style={{
                            marginTop: 20,
                            alignItems: "center"
                          }}
                        >
                          <Form.Item
                            name={["organisationIndexList", index]}
                            className={"mb-0"}
                            label={translate(
                              "editors.case_decisions.index_data"
                            )}
                            rules={[
                              {
                                required: item.required,
                                message: translate(
                                  "editors.case_decisions.required_messages",
                                  {
                                    field: translate(
                                      "editors.case_decisions.case_decision_type"
                                    )
                                  }
                                )
                              },
                              {
                                validator: (rule, value, callback) => {
                                  if (value && item.maxLength) {
                                    if (value.length > item.maxLength) {
                                      callback(
                                        `${translate(
                                          "editors.case_law_documents.index.max_length"
                                        )} ${item.maxLength}`
                                      );
                                    } else if (value.length <= item.maxLength) {
                                      callback();
                                    }
                                  } else {
                                    callback();
                                  }
                                  return;
                                }
                              }
                            ]}
                          >
                            <Select
                              placeholder={translate(
                                "editors.case_law_documents.select_index_data"
                              )}
                              mode="multiple"
                              showSearch
                              optionFilterProp="children"
                              className={"png-tagbox"}
                              onChange={(idList: []) => {
                                openIndexDataModal(
                                  item.organisationIndexList?.filter(
                                    (i) => i.id === idList[idList.length - 1]
                                  )[0],
                                  idList,
                                  index
                                );
                              }}
                            >
                              {renderOptions(
                                filterIndexData(
                                  item.organisationIndexList,
                                  index
                                )
                              )}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  })}
                </Spin>
              </FormSection>
            )}
            <IndexAttributeDataForm
              closeIndexDataModal={closeIndexDataModal}
              indexAttributeDataList={indexAttributeDataList}
              indexDataModalVisible={indexDataModalVisible}
              indexTypeAttributes={indexTypeAttributes}
              saveAttributeData={saveAttributeData}
              form={form}
              setAttributesData={setAttributesData}
              translate={translate}
              selectedIndexForAttribute={selectedIndexForAttribute}
            />

            <CourtCaseEntryForm
              courtCase={courtCase}
              translate={translate}
              visible={courtCaseDetailsModalVisible || false}
              onHide={onHideCourtCaseDetailsModal}
              onSetCourtCaseSelectionResult={updateCourtCaseSelection}
              courtCaseConnectionTypeList={courtCaseConnectionTypeList}
              form={form}
              decisionTypes={decisionTypes}
            />
          </Card>
        </Col>
      </Row>
      <Row justify="center">
        <Col
          lg={20}
          md={24}
          sm={24}
          xs={24}
          style={{ textAlign: "right", paddingTop: 20 }}
        >
          <Button
            type="text"
            danger
            onClick={() => {
              form.resetFields();
              showCaseLawDocumentList();
            }}
          >
            <CloseOutlined /> {translate("data_grid.modal.actions.cancel")}
          </Button>
          <Button
            type={"primary"}
            onClick={() => {
              form
                .validateFields()
                .then((values) => {
                  onRaiseValidationError(null);
                  onSubmit(values);
                })
                .catch((result) => {
                  let errors: any[] = result?.errorFields;
                  if (errors) {
                    onRaiseValidationError(
                      errors.filter(
                        (item) => item.name?.indexOf("decisionDate") > -1
                      )
                    );
                  }
                });
            }}
          >
            <CheckOutlined /> {translate("data_grid.modal.actions.save")}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
export default CaseLawDocumentForm;
